import React from 'react';

import classNames from 'classnames';

export interface IIndicatorWithoutArrowProps {
    number: number;
    color?: TIndicatorWithoutArrowColor;
    className?: string;
}

export type TIndicatorWithoutArrowColor = 'red' | 'green' | 'grey';

const IndicatorWithoutArrow = (props: IIndicatorWithoutArrowProps): JSX.Element => {
    const className: string = classNames(
        'indicator',
        {
            [`indicator--color-${props.color}`]: !!props.color,
        },
        props.className,
    );

    return (
        <div className={className}>
            <span className="indicator__text text-small">
                {props.number + ' %'}
            </span>
        </div>
    );
};

export default IndicatorWithoutArrow;
